import React from "react";
import { useEffect, useState } from "react";
import { Row, Col, Table } from "react-bootstrap";
import "./home.css";

function Home() {
  /**
   * State creation
   *  Etablissement
   *  Beneficiaire
   *  DailyEtablissement
   *  DailyBeneficiaire
   *
   */
  const [etablissement, setEtablissement] = useState([]);
  const [beneficiaire, setBeneficiaire] = useState([]);
  const [dailyEtablissement, setDailyEtablissement] = useState([]);
  const [dailyBeneficiaire, setDailyBeneficiaire] = useState([]);
  /**
   * Get All Etablissement
   */
  const getEtablissement = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/backOffice/getEtablissement",
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          const monProfil = responseObject;
          setEtablissement(monProfil.length);
        },

        (error) => {
        }
      );
  };

  /**
   * Get All Bénéficiaire
   */
  const getBeneficiaire = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/backOffice/getBeneficiaire",
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          const monProfil = responseObject;
          setBeneficiaire(monProfil.length);
        },

        (error) => {
        }
      );
  };

  /**
   * Get Daily Bénéficiaire
   */
  const getDailyBeneficiaire = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/backOffice/getDailyBeneficiaire",
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          const monProfil = responseObject;
          setDailyBeneficiaire(monProfil.length);
        },

        (error) => {
        }
      );
  };

  /**
   * Get Daily Etablissement
   */
  const getDailyEtablissement = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/backOffice/getDailyEtablissement",
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          const monProfil = responseObject;
          setDailyEtablissement(monProfil.length);
        },

        (error) => {
        }
      );
  };

  useEffect(() => {
    // Call of all the get
    getEtablissement();
    getBeneficiaire();
    getDailyBeneficiaire();
    getDailyEtablissement();
  }, []);

  return (
    <div>
      <Row>
        <Col>
          <h2>Vision d'ensemble</h2>
        </Col>
      </Row>
      <div className="rowBox">
        <div className="element">
          <h4> Nombre d'établissements</h4>
          <h4>{etablissement}</h4>
        </div>
        <div className="element">
          <h4> Nombre de bénéficiaires</h4>
          <h4>{beneficiaire}</h4>
        </div>
        <div className="element">
          <h4> Nombre d'inscriptions aujourd'hui</h4>

          <h4>{dailyBeneficiaire + dailyEtablissement}</h4>
        </div>
      </div>
    </div>
  );
}

export default Home;
